import React, { Fragment } from "react";
import ContentLoader from "react-content-loader";

const CoachingDashboardSkeleton = (props) => {
  const { rows = 5, webAppTheme } = props;
  const rowHeight = 60;
  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";
  return (
    <ContentLoader
      viewBox={`0 0 1500 ${rowHeight * rows}`}
      {...props}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
    >
      {new Array(rows).fill(" ").map((el, index) => {
        const contentVerticalPosition = (contentHeight) =>
          rows > 1 ? contentHeight + rowHeight * index : contentHeight;
        return (
          <Fragment key={index}>
            <rect
              x="20"
              y={`${contentVerticalPosition(20)}`}
              rx="4"
              ry="4"
              width="300"
              height="20"
            />
            <rect
              x="400"
              y={`${contentVerticalPosition(20)}`}
              rx="10"
              ry="4"
              width="1200"
              height="20"
            />

            <rect
              y={`${contentVerticalPosition(59)}`}
              x="10"
              ry="10"
              width="1500"
              height="1"
            />
          </Fragment>
        );
      })}
    </ContentLoader>
  );
};

export default CoachingDashboardSkeleton;
